<!-- _/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/
_/                                                                                                                    _/
_/      「データ管理の達人」からのインポート(STDSDC01C19)                                                                _/
_/                                                                                                                    _/
_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/_/ -->
<template>
  <BaseModal :show="isImportFromTDKShow">
    <!-- ポップアップ：処理中 -->
    <div class="popup" style="width: 1000px">
      <div class="popup-head">「データ管理の達人」からのインポート</div>
      <div class="popup-body blue">
        <!--****  メッセージ表示領域 **** -->
        <p class="errMsg title-ico ico-warning" v-show="errors != ''">
          <ErrorMessage is-modal-error :errors="errors"></ErrorMessage>
        </p>
        <div>
            <p>「データ管理の達人」から事業者情報のインポートを行います。</p>
            <p>接続先を選択してください。</p>
            <p>※事業者コードが一致する事業者情報は上書きされます。</p>
            <p>※「決算日」については以下の方式でインポートされますので、インポート後に事業者情報をご確認ください。</p>
            <p style="text-indent: 1em">・「法人個人区分」が「法人」の場合</p>
            <p style="text-indent: 2em">・「データ管理の達人」の「決算日」が入力されている場合：「決算日」の末日が設定されます。</p>
            <p style="text-indent: 2em">・「データ管理の達人」の「決算日」が入力されていない場合：「3月31日」が設定されます。</p>
            <p style="text-indent: 1em">・「法人個人区分」が「個人」の場合</p>
            <p style="text-indent: 2em">・「決算日」は一律「12月31日」が設定されます。</p>
        </div>
        <br />
        <div>
          <span class="frm-label w-75px">接続先：</span>
          <input
            type="text"
            class="frm-text frm-size-l"
            v-model="selectedDBName"
            disabled="disabled"
          />
          <button
            class="frm-btn strong"
            data-role="popup-open"
            data-target="#popup-dblist"
            ref="referenceCubeDBButton"
            @click="referenceCubeDBClick"
          >
            参照
          </button>
        </div>
        <br />
        <div class="frm-item alignright">
          <div v-show="totalCount" class="frm-item grow right">
            <p v-show="totalCount">{{ totalCount.toLocaleString() }}件</p>
          </div>
        </div>
        <div class="table-scroll-header">
          <!-- 一覧ヘッダー -->
          <table class="table-select multi-select">
            <colgroup>
              <!--チェックボックス-->
              <col style="width: 30px" />
              <!--事業者コード-->
              <col style="width: 200px" />
              <!--事業者名-->
              <col style="width: auto" />
              <!--法人個人区分-->
              <col style="width: 150px" />
              <!--保存日時-->
              <col style="width: 125px" />
            </colgroup>
            <thead>
              <tr>
                <!-- 全選択,全選択解除 -->
                <th class="multi-select-item aligncenter">
                  <label class="frm-checkbox">
                    <input
                      type="checkbox"
                      :checked="isAllSelected"
                      @change="selectAllRow"
                    />
                    <span
                      class="checkbox-item"
                      tabindex="0"
                      @keydown.space.stop.prevent="selectAllRow"
                    ></span>
                  </label>
                </th>
                <th
                  class="alignleft sort hover"
                  @click="changeSortKey('businessOperatorCode')"
                >
                  事業者コード
                  <div class="sort-toggle">
                    <button
                      class="sort-toggle-asc"
                      :class="
                        sort.key == 'businessOperatorCode' && sort.isAsc
                          ? 'on'
                          : ''
                      "
                      type="button"
                    >
                      asc
                    </button>
                    <button
                      class="sort-toggle-desc"
                      :class="
                        sort.key == 'businessOperatorCode' && !sort.isAsc
                          ? 'on'
                          : ''
                      "
                      type="button"
                    >
                      desc
                    </button>
                  </div>
                </th>
                <th
                  class="alignleft sort hover"
                  @click="changeSortKey('businessOperatorName')"
                >
                  事業者名
                  <div class="sort-toggle">
                    <button
                      class="sort-toggle-asc"
                      :class="
                        sort.key == 'businessOperatorName' && sort.isAsc
                          ? 'on'
                          : ''
                      "
                      type="button"
                    >
                      asc
                    </button>
                    <button
                      class="sort-toggle-desc"
                      :class="
                        sort.key == 'businessOperatorName' && !sort.isAsc
                          ? 'on'
                          : ''
                      "
                      type="button"
                    >
                      desc
                    </button>
                  </div>
                </th>
                <th
                  class="sort hover"
                  @click="changeSortKey('businessOperatorType')"
                >
                  法人個人区分
                  <div class="sort-toggle">
                    <button
                      class="sort-toggle-asc"
                      :class="
                        sort.key == 'businessOperatorType' && sort.isAsc
                          ? 'on'
                          : ''
                      "
                      type="button"
                    >
                      asc
                    </button>
                    <button
                      class="sort-toggle-desc"
                      :class="
                        sort.key == 'businessOperatorType' && !sort.isAsc
                          ? 'on'
                          : ''
                      "
                      type="button"
                    >
                      desc
                    </button>
                  </div>
                </th>
                <th class="sort hover" @click="changeSortKey('dataUpdateDate')">
                  保存日時
                  <div class="sort-toggle">
                    <button
                      class="sort-toggle-asc"
                      :class="
                        sort.key == 'dataUpdateDate' && sort.isAsc ? 'on' : ''
                      "
                      type="button"
                    >
                      asc
                    </button>
                    <button
                      class="sort-toggle-desc"
                      :class="
                        sort.key == 'dataUpdateDate' && !sort.isAsc ? 'on' : ''
                      "
                      type="button"
                    >
                      desc
                    </button>
                  </div>
                </th>
              </tr>
            </thead>
          </table>
        </div>
        <div
          class="table-scroll-body"
          style="height: 250px; background-color: #ffffff"
          ref="cubBopInfoTable"
        >
          <table
            class="table-select multi-select scroll"
            style="width: 100%; table-layout: fixed"
          >
            <colgroup>
              <!--チェックボックス-->
              <col style="width: 30px" />
              <!--事業者コード-->
              <col style="width: 200px" />
              <!--事業者名-->
              <col style="width: auto" />
              <!--法人個人区分-->
              <col style="width: 150px" />
              <!--保存日時-->
              <col style="width: 125px" />
            </colgroup>
            <tbody>
              <tr
                v-for="info in cubeBopInfoHeaderList"
                :key="info.businessOperatorCode"
                :class="[info.selected ? 'selected' : '']"
              >
                <td class="multi-select-item aligncenter">
                  <label class="frm-checkbox">
                    <input
                      type="checkbox"
                      @change="selectRow(info)"
                      :checked="info.selected"
                      :value="info.businessOperatorCode"
                    />
                    <span
                      class="checkbox-item"
                      tabindex="0"
                      @keydown.space.stop.prevent="selectRow(info)"
                    ></span>
                  </label>
                </td>
                <!--事業者コード-->
                <td>
                  <span>{{ info.businessOperatorCode }}</span>
                </td>
                <!--事業者名-->
                <td>
                  <span>{{ info.businessOperatorName }}</span>
                </td>
                <!--法人個人区分-->
                <td class="aligncenter">
                  <span>
                    {{ corporationIndividualFormat(info.businessOperatorType) }}
                  </span>
                </td>
                <!--保存年月日-->
                <td class="aligncenter">
                  <span>
                    {{ formatDateTime_Date(info.dataUpdateDate) }}
                  </span>
                  <br />
                  <span>
                    {{ formatDateTime_Time(info.dataUpdateDate) }}
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
          <table class="table-select single-select" v-show="noDataPrompt">
            <tbody>
              <tr>
                <p class="noData-area">
                  {{ noDataMsg }}
                </p>
              </tr>
            </tbody>
          </table>
        </div>
        <p class="errMsg alignleft" v-show="errors_cubeBopInfo != ''">
          <ErrorMessageCase :errors="errors_cubeBopInfo"></ErrorMessageCase>
        </p>
        <div class="footer-btn frm-btn-row">
          <div class="frm-item grow center">
            <button
              class="frm-btn strong large"
              data-role="popup-open"
              data-target="#popup-process"
              @click="importButtonClick"
            >
              インポート
            </button>
            <button
              ref="cancelButton"
              class="frm-btn large"
              data-role="popup-close"
              @click="cancelButtonClick"
            >
              キャンセル
            </button>
          </div>
        </div>
      </div>
    </div>
    <STDSDC01C08ProcessingConfirmModal
      :isConfirmShow="isConfirmShow"
      :isFileSelectedShow="false"
      :textArea="
        exportErrorFlag
          ? common.getMessage('MTCL2118', ['インポート', 'インポート'])
          : common.getMessage('MTCL9099')
      "
      :noBtnHidden="exportErrorFlag"
      @agree="agree($event)"
      @disagree="disagree"
    />

    <STDSDC01C20BusinessDBListModal
      v-model:isBuisinessDBListShow="isBuisinessDBListModalShow"
      v-model:selectedDBKeyName="selectedDBKeyName"
      v-model:selectedDBName="selectedDBName"
      @changeCubeBopDatabase="changeCubeBopDatabase"
    />

    <STDSDC01C21ProcessingProgressModal
      :pageId="pageId"
      :total="selectedCubeBopInfoList.length"
      :isShow="isProcessingShow"
      @processingOver="processingOver(false)"
      @processingError="processingOver(true)"
      @exception="importException"
    />
  </BaseModal>
</template>

<script>
import moment from "moment";
import BaseModal from "@/components/Base/BaseModal.vue";
import Common from "@/util/common";
import ErrorMessage from "@/components/ErrorMessage.vue";
import ErrorMessageCase from "@/components/ErrorMessageCase.vue";
import { getCSVLogByPageID } from "@/api/Common/Log";
import { mapMutations } from "vuex";
import {
  API_DisplayCubeBopImport,
  API_ChangeCubeBopDatabase,
  API_ImportCubeBopInfo,
} from "@/api/Modules/DC01/STDSDC01C19";
import {
  API_ProcessingInfoInitClear,
  API_GetString,
} from "@/api/Modules/CM04/STDSCM04C00";
import STDSDC01C08ProcessingConfirmModal from "@/components/STDSDC01C08ProcessingConfirmModal.vue";
import STDSDC01C20BusinessDBListModal from "@/components/STDSDC01C20BusinessDBListModal.vue";
import STDSDC01C21ProcessingProgressModal from "@/components/STDSDC01C21ProcessingProgressModal.vue";
import { CORPORATION_INDIVIDUAL_DIVISION } from "@/util/enum";

export default {
  name: "STDSDC01C19",
  components: {
    BaseModal,
    ErrorMessage,
    ErrorMessageCase,
    STDSDC01C08ProcessingConfirmModal,
    STDSDC01C20BusinessDBListModal,
    STDSDC01C21ProcessingProgressModal,
  },
  data() {
    return {
      totalCount: 0, // Cube事業者総数
      cubeBopInfoHeaderList: [], // Cube事業者情報リスト
      selectedCubeBopInfoList: [], // 選択中Cube事業者情報リスト
      errors: [],
      errors_cubeBopInfo: [],
      sort: {
        key: "", // ソートキー
        isAsc: true, // 昇順ならtrue,降順ならfalse
      },
      noDataPrompt: false,
      noDataMsg: Common.getMessage("MTCL1118", ["事業者情報"]),

      // 処理確認(C01C07)画面設定
      isConfirmShow: false,
      exportErrorFlag: false,

      // 接続先、事業者データベース一覧画面(C01C20)設定
      selectedDBKeyName: "",
      selectedDBName: "",
      isBuisinessDBListModalShow: false,

      // 処理中(C01C21)画面設定
      isProcessingShow: false,

      common: Common,
    };
  },

  props: {
    // 当画面表示定義
    isImportFromTDKShow: {
      type: Boolean,
      required: true,
    },
    pageId: {
      type: String,
      required: true,
    },
  },

  watch: {
    isImportFromTDKShow: function (newVal) {
      if (newVal) {
        // 表示初期化
        this.initView();
      }
    },
  },

  computed: {
    // すべて選択チェックボックス選択状態判定
    isAllSelected() {
      if (this.noDataPrompt) {
        return false;
      } else {
        return this.cubeBopInfoHeaderList.every((info) => info.selected);
      }
    },
  },

  methods: {
    ...mapMutations("businessModule", ["processDialogue"]),

    //#region 画面制御
    // 画面情報初期化
    initView() {
      // 子画面を非表示にする。
      this.isConfirmShow = false;
      this.isBuisinessDBListModalShow = false;
      this.isProcessingShow = false;

      // 画面情報を初期化する
      this.errorClear();
      this.sort.key = "";

      // 「データ管理の達人」既定のデータベース情報を取得しリストに反映する
      // 「処理中」表示
      this.processDialogue(true);
      API_DisplayCubeBopImport()
        .then((response) => {
          // 正常終了の場合取得したリストを更新する
          if (response.result == "0000") {
            this.selectedDBKeyName = response.dbKeyName;
            this.selectedDBName = response.dbName;
            this.cubeBopInfoHeaderList = response.cubeBopInfoHeader;
            if (this.cubeBopInfoHeaderList == null) {
              this.totalCount = 0;
              this.noDataPrompt = true;
            } else {
              this.totalCount = this.cubeBopInfoHeaderList.length;
              this.noDataPrompt = this.totalCount == 0;
              this.cubeBopInfoHeaderList.forEach(
                (collectStatus) => (collectStatus.selected = false)
              );
            }
          } else {
            // エラーの場合事業者情報を表示しないようにする。
            this.selectedDBKeyName = "";
            this.selectedDBName = "";
            this.cubeBopInfoHeaderList = [];
            this.totalCount = 0;
            this.noDataPrompt = true;

            // エラー表示
            if (response.errorMSG) {
              this.errors.push(
                Common.createError(response.errorCD, response.errorMSG)
              );
            } else {
              this.errors.push(
                Common.createError(
                  response.errorCD,
                  Common.getMessage(response.errorCD, [])
                )
              );
            }
          }
          return;
        })
        .finally(() => {
          // 「処理中」非表示
          this.processDialogue(false);

          // 初期フォーカス設定
          this.$nextTick(() => {
            this.initFocus();
          });
        });
    },

    errorClear() {
      // エラー情報をクリアする。
      this.errors = [];
      this.errors_cubeBopInfo = [];
    },

    // ソートキー変更
    changeSortKey(key) {
      Common.changeSortKey(this.sort, key);
      this.cubeBopInfoHeaderList = Common.listSort(
        this.sort.key,
        this.sort.isAsc,
        this.cubeBopInfoHeaderList
      );
    },

    // 行選択時の処理
    selectRow(info) {
      let cubeBopInfoHeaderStatus = this.cubeBopInfoHeaderList.find(
        (cubeBopInfoStatus) =>
          cubeBopInfoStatus.businessOperatorCode === info.businessOperatorCode
      );
      cubeBopInfoHeaderStatus.selected = !cubeBopInfoHeaderStatus.selected;
    },

    // すべて選択チェックボックス変更時処理
    selectAllRow() {
      if (this.isAllSelected) {
        this.cubeBopInfoHeaderList.forEach((info) => {
          info.selected = false;
        });
      } else {
        this.cubeBopInfoHeaderList.forEach((info) => {
          info.selected = true;
        });
      }
    },

    // 初期フォーカス設定
    initFocus() {
      this.$refs.referenceCubeDBButton.focus();

      // 複数回開いた場合に前回スクロール位置で再表示されてしまうため、フォーカス位置を先頭行に設定する
      this.$refs.cubBopInfoTable.scrollTop = 0;
    },

    // 法人個人区分のフォーマット
    corporationIndividualFormat(data) {
      if (data == CORPORATION_INDIVIDUAL_DIVISION.LegalEntity.code) {
        return CORPORATION_INDIVIDUAL_DIVISION.LegalEntity.text;
      } else if (data == CORPORATION_INDIVIDUAL_DIVISION.Individual.code) {
        return CORPORATION_INDIVIDUAL_DIVISION.Individual.text;
      } else if (data == CORPORATION_INDIVIDUAL_DIVISION.Both.code) {
        return CORPORATION_INDIVIDUAL_DIVISION.Both.text;
      }
    },

    // 日付のフォーマット(YYYY/MM/DD)
    formatDateTime_Date(value) {
      if (value) {
        return moment(String(value)).format("YYYY/MM/DD");
      }
    },

    // 日付のフォーマット(HH:mm:ss)
    formatDateTime_Time(value) {
      if (value) {
        return moment(String(value)).format("HH:mm:ss");
      }
    },
    //#endregion

    //#region 事業者データベース変更
    // 接続先データベース変更ダイアログ表示
    referenceCubeDBClick() {
      this.errorClear();
      this.isBuisinessDBListModalShow = true;
      return;
    },

    // 接続先データベース変更
    changeCubeBopDatabase() {
      this.isBuisinessDBListModalShow = false;
      const param = {
        dbKeyName: this.selectedDBKeyName,
      };

      // 「データ管理の達人」接続先データベースを変更し一覧を更新する
      // 「処理中」表示
      this.processDialogue(true);
      API_ChangeCubeBopDatabase(param)
        .then((response) => {
          // 正常終了の場合取得したリストを更新する
          if (response.result == "0000") {
            this.cubeBopInfoHeaderList = response.cubeBopInfoHeader;
            if (this.cubeBopInfoHeaderList == null) {
              this.totalCount = 0;
              this.noDataPrompt = true;
            } else {
              this.totalCount = this.cubeBopInfoHeaderList.length;
              this.noDataPrompt = this.totalCount == 0;
              this.cubeBopInfoHeaderList.forEach(
                (collectStatus) => (collectStatus.selected = false)
              );
            }
          } else {
            // エラーの場合事業者情報を表示しないようにする。
            this.selectedDBKeyName = "";
            this.selectedDBName = "";
            this.cubeBopInfoHeaderList = [];
            this.totalCount = 0;
            this.noDataPrompt = true;

            // エラー表示
            if (response.errorMSG) {
              this.errors.push(
                Common.createError(response.errorCD, response.errorMSG)
              );
            } else {
              this.errors.push(
                Common.createError(
                  response.errorCD,
                  Common.getMessage(response.errorCD, [])
                )
              );
            }
          }
          return;
        })
        .finally(() => {
          // リストの内容更新に合わせてスクロール位置を先頭に戻す
          this.$refs.cubBopInfoTable.scrollTop = 0;
          // 「処理中」非表示
          this.processDialogue(false);
        });
    },
    //#endregion

    //#region インポート処理
    // インポートボタン押下
    importButtonClick() {
      this.errorClear();

      let tempCubeBopData = {
        bopEmpId: null,
        empName: null,
        empCollectStatus: null,
        empCollectMode: null,
        submitDate: null,
        resubmitDate: null,
        eMailAddress: null,
      };
      let selectedCubeBopInfoList = [];

      // 選択中の事業者情報を取得
      this.cubeBopInfoHeaderList.forEach((cubeBopInfo) => {
        if (cubeBopInfo.selected) {
          // 事業者キー名
          tempCubeBopData.businessOperatorKeyName =
            cubeBopInfo.businessOperatorKeyName;
          // 事業者コード
          tempCubeBopData.businessOperatorCode =
            cubeBopInfo.businessOperatorCode;
          // 事業者名
          tempCubeBopData.businessOperatorName =
            cubeBopInfo.businessOperatorName;
          // 事業者種別(法人個人区分)
          tempCubeBopData.businessOperatorType =
            cubeBopInfo.businessOperatorType;
          // データ更新日時
          tempCubeBopData.dataUpdateDate = cubeBopInfo.dataUpdateDate;
          selectedCubeBopInfoList.push({ ...tempCubeBopData });
        }
      });

      // 選択事業者が存在しない場合エラー
      if (selectedCubeBopInfoList.length == 0) {
        this.isCollectionRequestDisabled = false;
        this.errors_cubeBopInfo.push(
          Common.createError("MTCL9109", Common.getMessage("MTCL9109", []))
        );
        this.errors.push(
          Common.createError("MTCL1119", Common.getMessage("MTCL1119", []))
        );
        return;
      }

      // 処理中セッション情報初期化
      const initParam = {
        pageId: this.pageId,
        processTotal: selectedCubeBopInfoList.length,
      };
      API_ProcessingInfoInitClear(initParam).then((response) => {
        // エラーとなった場合、処理を停止する
        if (response.result != "0000") {
          this.errors.push(
            Common.createError(
              response.errorCD,
              Common.getMessage(response.errorCD, [])
            )
          );
          return;
        } else {
          // C01C21処理中画面クローズ
          this.isProcessingShow = true;

          // 「データ管理の達人」からの事業者情報インポートを実施する
          const param = {
            dbKeyName: this.selectedDBKeyName,
            dbName: this.selectedDBName,
            cubeBopInfoHeader: selectedCubeBopInfoList,
            pageID: this.pageId,
          };
          API_ImportCubeBopInfo(param).then((response) => {
            if (response.result == "0000") {
              this.importLogList = response.ImportLogList;
              this.hasErrorLog = response.HasErrorLog;
            } else {
              // エラー初期化
              this.errorClear();
              errors.push(
                Common.createError(
                  response.errorCD,
                  Common.getMessage(response.errorCD, [])
                )
              );
            }
            return;
          });
        }
      });
    },

    // STDC01C21 処理完了
    // @errorFlag エラーありフラグ（ディフォルトは false ）
    processingOver(errorFlag = false) {
      // C01C21処理中画面クローズ
      this.isProcessingShow = false;
      // エラーありフラグを設定
      this.exportErrorFlag = errorFlag;
      // ログを出力確認ダイアログ表示
      this.isConfirmShow = true;
    },

    // STDC01C21 例外処理
    importException() {
      // C01C21処理中画面クローズ
      this.isProcessingShow = false;

      // 汎用処理中画面表示
      this.processDialogue(true);
      API_GetString({
        StorageKey: `${this.pageId}_Import_Result`,
      })
        .then((response) => {
          // 正常の場合
          if (_.eq(response.result, "0000")) {
            // レスポンスをJSONに変換
            const errorObj = JSON.parse(response.string);
            // 異常処理
            this.requestError(errorObj.ErrorCD, errorObj.errorName);
          }
        })
        .finally(() => {
          this.processDialogue(false);
        });
    },

    // **********************************************
    // エラー共通処理
    // **********************************************
    requestError(errorCode, errMsg) {
      // エラー初期化
      this.errors = [];

      if (
        _.includes(
          [
            "MTCL1001",
            "MTCL1003",
            "MTCL1004",
            "MTCL1006",
            "MTCL1007",
            "MTCL1011",
            "MTCL1034",
            "MTCL1049",
            "MTCL1098",
          ],
          errorCode
        )
      ) {
        this.errors.push(
          Common.createError(
            errorCode,
            Common.getMessage(errorCode, [errMsg[0]])
          )
        );
      } else if (
        _.includes(["MTCL1014", "MTCL1018", "MTCL1051", "MTCL1103"], errorCode)
      ) {
        this.errors.push(
          Common.createError(
            errorCode,
            Common.getMessage(errorCode, [errMsg[0], errMsg[1]])
          )
        );
      } else if (_.includes(["MTCL1010"], errorCode)) {
        this.errors.push(
          Common.createError(
            errorCode,
            Common.getMessage(errorCode, [errMsg[0], errMsg[1], errMsg[2]])
          )
        );
      } else {
        this.errors.push(
          Common.createError(errorCode, Common.getMessage(errorCode, errMsg))
        );
      }
    },

    // 処理確認画面ダイアログでOKが選択された時の処理
    agree() {
      getCSVLogByPageID(this.pageId)
        .then(() => {
          this.isConfirmShow = false;
        })
        .finally(() => {
          this.errorClear();
          this.$emit("reload");
        });
    },

    // 処理確認画面ダイアログでキャンセルが選択された時の処理
    disagree() {
      this.isConfirmShow = false;
      this.errorClear();
      this.$emit("reload");
    },
    //#endregion

    // キャンセルボタン押下
    cancelButtonClick() {
      this.$emit("cancel");
    },
  },
};
</script>
;
